<!-- Two compact lines, so the row keeps the table's usual height -->
<div class="flex min-w-0 flex-col">
  @if (finished()) {
    <span
      data-sla-date
      class="flex items-center gap-x-sm whitespace-nowrap text-xs font-medium leading-4 text-neutral-900">
      <span dir="ltr">{{ finishedAt() | date: 'dd-MMM-yyyy hh:mm a' }}</span>
      @if (finishedLate()) {
        <lib-warning-icon [iconClass]="'size-4 text-destructive-500'" />
      }
    </span>
  } @else if (dueDate(); as dueDate) {
    <span
      data-sla-date
      libSla
      class="whitespace-nowrap text-xs font-medium leading-4"
      [clockTemplate]="onHold() ? holdIcon : clockIcon"
      [sla]="dueDate"
      dir="ltr">
      {{ eta() ? 'ETA: ' : '' }}{{ dueDate | date: 'dd-MMM-yyyy hh:mm a' }}
    </span>
  } @else {
    <span data-sla-date class="text-xs italic leading-4 text-neutral-400">
      {{ 'inbox_sla_no_sla_placeholder' | transloco }}
    </span>
  }
  @if (remaining()) {
    <!-- Lined up under the date, past the clock icon -->
    <span
      data-sla-remaining
      class="mt-x-sm whitespace-nowrap text-[0.65rem] leading-3 text-neutral-500 rtl:text-xs2 rtl:leading-4"
      [class]="dueDate() && !finished() ? 'ps-[1.25rem]' : ''">
      {{ remaining() }}
    </span>
  }
</div>

<ng-template #clockIcon let-isOverdue>
  <lib-clock-icon
    [iconClass]="
      'size-4 ' + (isOverdue ? 'text-destructive-500' : 'text-neutral-500')
    " />
</ng-template>

<ng-template #holdIcon let-isOverdue>
  <lib-hold-icon
    [iconClass]="
      'size-4 ' + (isOverdue ? 'text-destructive-500' : 'text-neutral-500')
    " />
</ng-template>
